"use client"

import type React from "react"
import { Box, Container, Typography, Button, Grid, Paper, useTheme, useMediaQuery } from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"

const HeroSection: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        py: { xs: 8, md: 12 },
        color: "white",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.1,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Typography variant="h1" component="h1" gutterBottom>
              Find the Perfect Cook or Maid Effortlessly!
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
              Tired of searching through endless profiles? Post your requirement and get responses from 1000+ verified
              cooks and maids effortlessly!
            </Typography>

            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, mt: 4 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                href="#how-it-works"
                sx={{
                  borderWidth: 2,
                  fontWeight: "bold",
                  fontSize: "1rem",
                  px: 4,
                  py: 1.5,
                }}
              >
                How It Works
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end" }}>
            <Box
              sx={{
                width: { xs: 280, md: 320 },
                height: { xs: 560, md: 640 },
                position: "relative",
                mt: { xs: 4, md: 0 },
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  borderRadius: "40px",
                  overflow: "hidden",
                  border: "8px solid black",
                  bgcolor: "black",
                }}
              >
                <Box
                  component="img"
                  src={require("../../assets/home-screen.jpg")}
                  alt="Mobile app preview"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "32px",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default HeroSection
